import React, {Component} from 'react'
import Link from 'gatsby-link'
import Button from "../components/Button"
import Divider from "../components/Divider"
import Typer from "../components/Typer"
import Widget from '../components/Widget'
import Widgets from "../components/Widgets"
import Helmet from 'react-helmet'

import image_campus from '../images/campus-map.png'
import icon_circle from '../images/circle-icon.svg'
import image_circle2 from '../images/circle2.svg'
import icon_custom from '../images/custom-icon.svg'

import devices_bg from '../images/devices-bg.png'
import icon_fidelity from '../images/fidelity-icon.svg'
import image_flight from '../images/flight.png'
import image_food from '../images/food.png'
import icon_intelligence from '../images/intelligence-icon.svg'
import image_ipad2 from '../images/ipad2.png'
import image_iphone3 from '../images/iphone3.png'
import image_lounges from '../images/lounges.png'
import image_mac from '../images/mac.png'

import image_map from '../images/map-logo.png'
import icon_offline from '../images/offline-icon.svg'
import icon_online from '../images/online-icon.svg'
import icon_onsite from '../images/onsite-icon.svg'

import icon_pen from '../images/pen-icon.svg'
import image_pin from '../images/pin.png'

import image_pipe from '../images/pipe-line.svg'
import icon_puzzle from '../images/puzzle-icon.svg'
import image_restrooms from '../images/restrooms.png'
import icon_sdk from '../images/sdk-icon.svg'
import image_search2 from '../images/search2.svg'
import icon_services from '../images/services-icon.svg'
import image_shops from '../images/shops.png'
import image_smphone from '../images/smphone.png'
import image_tablet from '../images/tablet.png'
import icon_timely from '../images/timely-icon.svg'
import image_watch from '../images/watch.png'
import icon_wayfinding from '../images/wayfinding-icon2.svg'

import { navigateTo } from "gatsby-link"

class locusMapsPage extends Component {

  constructor(props) {
    super(props)

      this.state = {
        enabled: false,
        intervalId: null
      }

      this.onClickHandler = this.onClickHandler.bind(this)
      this.loopLocusMaps = this.loopLocusMaps.bind(this)
  }

  onClickHandler(event) {
    window.clearInterval(this.state.intervalId)

    this.setState((prevState) => {
      return {
        enabled: true,
        intervalId: prevState.intervalId
      }
    })
  }

  loopLocusMaps(){
      const intervalId = setInterval(()=>{
          LocusMaps({ command: "resetMap" })
              .then(function() {
                  return LocusMaps({command: "setPosition", lat: 47.444087, lng: -122.302758})
              })
              .then(function() {
                  return LocusMaps({ command: "zoom", to: 100, time: 5000 })
              })
      },10000)

      this.setState((prevState) => {
          return {
              enabled: prevState.enabled,
              intervalId: intervalId
          }
      })
  }

  componentDidMount() {
    // this.LocusMaps = require('https://js.locuslabs.com/latest/locusmaps.js')
    this.LocusMaps = require('../executables/locusmaps.js')
    window.LocusMaps = this.LocusMaps
    this.loopLocusMaps()
  }

  render() {
    return (
      <main id="main" role="main" style={{ marginTop: '134px' }}>
        <Helmet title="LocusMaps - indoor maps, search, and wayfinding on any device"/>
        <section className="intro viewport-section">
          <div className="inner-container">
            <div className="description">
              <div className="align">
                <div className="logo-icon">
                  <img
                    src={image_map}
                    alt=""
                    width="216"
                    height="62"
                  />
                </div>
                <h1>
                  Build amazing, customized location experiences <br />on any device.
                </h1>
                <div className="text">
                  <p>
                      LocusMaps is a series of SDKs that easily integrate into your existing apps to provide location context. The SDK includes far more than indoor maps. Built-in features like location-aware search, walking directions and indoor positioning make it easy to build rich location experiences in days - not months.
                  </p>
                </div>
                <div className="btn btn-red btn-text" onClick={() => navigateTo('/#contact/')}>SCHEDULE A DEMO</div>
              </div>
            </div>
            <div className="intro-image">
              <div className="ipade">
                <img
                  src={image_ipad2}
                  alt="image description"
                  width="1068"
                  height="767"
                />
              </div>
            </div>
          </div>
        </section>
        <section className="products-section container">
          <Divider />
          <Widgets widgets={[
              { image: icon_sdk, imageWidth: "43", imageHeight: "45", title: "LocusMaps SDK", description: "A comprehensive framework to location-enable your mobile and desktop applications. Built-in features like search, indoor positioning, and wayfinding bundled with a customizable interface." },
              { image:icon_online, imageWidth:"56", imageHeight:"46", title:"LocusMaps Online", description:"A complete indoor location experience without the expense of building your own web app. Maps, wayfinding, search and more all through a customizable web-based interface for desktop and mobile web browsers." },
              { image:icon_onsite, imageWidth:"43", imageHeight:"42", title:"LocusMaps Onsite", description:"All of the great location features of LocusMaps packaged for on-premise kiosks, displays and touchscreens.",}
          ]} />
        </section>
        <section className="campus-section container">
          <h2 data-bottom-top="opacity: 0;" data-center-top="opacity: 1;">
            The Complete Location Solution For Your Campus
          </h2>

          <div className="locusmaps-container" onClick={this.onClickHandler}>
              <div className="locusmaps" data-account-id="A11F4Y6SZRXH4X" data-venue-id="sea" data-controls="levels"/>
              { this.state.enabled ? null : <div className="locusmaps-overlay"/>}
          </div>

          <Widgets widgets={[
              { image: icon_pen, imageWidth:"60", imageHeight:"54", title:"Campus-wide Vector Maps", description:"High-fidelity vector maps delivered in an interactive user experience optimized for both beauty and utility." },
              { image: icon_services, imageWidth: "61", imageHeight: "61", title:"Location Services", description: "Give your visitors a “blue dot” inside and out using a hybrid of technologies including BLE beacons, WiFi, and geomagnetism - as well as 3rd party solutions such as smart lighting." },
              { image: icon_wayfinding, imageWidth:"37", imageHeight:"55", title:"Wayfinding", description:"The point-to-point pedestrian routing engine automatically determines the best route and transit time based on venue preferences. Dynamically reroute foot traffic when an escalator is out or a queue is too long." }
          ]}/>
        </section>
        <section className="api-support viewport-section">
          <div className="container">
            <div className="detail">
              <div
                className="align"
                data-bottom-top="opacity: 0;"
                data-center-top="opacity: 1;"
              >
                <i className="icon-wrap">
                  <img
                    src={icon_puzzle}
                    width="57"
                    height="57"
                    alt="image description"
                  />
                </i>
                <h2>API/SDK’s To Support Any Screen</h2>
                <p>
                    A collection of APIs and SDKs provide a powerful toolbox to build your own customized location experience on any screen. Utilize REST APIs to make use of location services in all kinds of applications including bots, wearables, and voice interfaces.
                </p>
              </div>
            </div>
            <div className="devices-holder">
              <div className="align">
                <div
                  className="devices-wrap"
                  style={{ backgroundImage: `url(${devices_bg})` }}
                >
                  <div
                    className="device mac"
                    data-bottom-top="transform:translatex(-50%) scale(0) rotate(-10deg);"
                    data-center-top="transform:translatex(-50%) scale(1) rotate(0deg);"
                  >
                    <img
                      src={image_mac}
                      alt="imag descripton"
                      width="396"
                      height="359"
                    />
                  </div>
                  <div
                    className="device phone"
                    data-bottom-top="transform:scale(0) rotate(-10deg);"
                    data-center-top="transform:scale(1) rotate(0deg);"
                  >
                    <img
                      src={image_smphone}
                      alt="imag descripton"
                      width="135"
                      height="222"
                    />
                  </div>
                  <div
                    className="device watch"
                    data-bottom-top="transform:translatex(-50%) scale(0);"
                    data-center-top="transform:translatex(-50%) scale(1);"
                  >
                    <img
                      src={image_watch}
                      alt="imag descripton"
                      width="108"
                      height="176"
                    />
                  </div>
                  <div
                    className="device tablet"
                    data-bottom-top="transform:scale(0) rotate(10deg);"
                    data-center-top="transform:scale(1) rotate(0deg);"
                  >
                    <img
                      src={image_tablet}
                      alt="imag descripton"
                      width="290"
                      height="202"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="location-aware">
          <Divider />
          <div className="container">
            <div
              className="detail"
              data-bottom-top="opacity: 0;"
              data-center-top="opacity: 1;"
            >
              <div className="align">
                <i className="icon-wrap">
                  <img
                    src={image_search2}
                    width="93"
                    height="57"
                    alt="image description"
                  />
                </i>
                <h2>Location Aware Search</h2>
                <p>
                    A powerful search engine enables users to search for anything. Search extends beyond simple point-of-interest names to include item categories, keywords, and product names.
                </p>
              </div>
            </div>
            <div className="phone-wrap">
              <div className="align">
                <div className="aware-phone">
                  <img
                    src={image_iphone3}
                    alt="imag descripton"
                    width="548"
                    height="1006"
                  />
                  <Typer />
                  <div
                    className="lounges"
                    data-bottom-top="transform:translatey(200px) scale(0)"
                    data-center-top="transform:translatey(0px) scale(1);"
                  >
                    <img
                      src={image_lounges}
                      alt="imag descripton"
                      width="352"
                      height="154"
                    />
                  </div>
                  <div
                    className="restrooms"
                    data-bottom-top="transform:translatey(200px) scale(0)"
                    data-center-top="transform:translatey(0px) scale(1);"
                  >
                    <img
                      src={image_restrooms}
                      alt="imag descripton"
                      width="341"
                      height="151"
                    />
                  </div>
                  <div
                    className="flight"
                    data-bottom-top="transform:translatey(200px) scale(0)"
                    data-center-top="transform:translatey(0px) scale(1);"
                  >
                    <img
                      src={image_flight}
                      alt="imag descripton"
                      width="325"
                      height="150"
                    />
                  </div>
                  <div
                    className="shops"
                    data-bottom-top="transform:translatey(200px) scale(0)"
                    data-center-top="transform:translatey(0px) scale(1);"
                  >
                    <img
                      src={image_shops}
                      alt="imag descripton"
                      width="259"
                      height="130"
                    />
                  </div>
                  <div
                    className="food"
                    data-bottom-top="transform:translate(-50%, 200px) scale(0)"
                    data-center-top="transform:translate(-50%, 0px) scale(1);"
                  >
                    <img
                      src={image_food}
                      alt="imag descripton"
                      width="259"
                      height="130"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="features-section container">
          <div className="description">
            <ul className="info-list">
              <li data-bottom-top="opacity: 0;" data-center-top="opacity: 1;">
                <i className="icon">
                  <img
                    src={icon_fidelity}
                    width="30"
                    height="28"
                    alt="image description"
                  />
                </i>
                <h3>
                  <a href="#">High Fidelity Data</a>
                </h3>
                <p>
                    Utilizing LocusLabs’ 3D Reality Capture System, our maps feature industry-leading accuracy and detail ranging from large spaces to objects as small as a power plug.
                </p>
              </li>
              <li data-bottom-top="opacity: 0;" data-center-top="opacity: 1;">
                <i className="icon">
                  <img
                    src={icon_timely}
                    width="31"
                    height="31"
                    alt="image description"
                  />
                </i>
                <h3>
                  <a href="#">Timely Updates</a>
                </h3>
                <p>
                    In the real world, maps and point-of-interest data can change increasing frequent intervals. Utilize LocusVMS to create and manage updates and then publish to all screens and applications to ensure users always have access to the latest.
                </p>
              </li>
              <li data-bottom-top="opacity: 0;" data-center-top="opacity: 1;">
                <i className="icon">
                  <img
                    src={icon_offline}
                    width="29"
                    height="29"
                    alt="image description"
                  />
                </i>
                <h3>
                  <a href="#">Offline Support</a>
                </h3>
                <p>
                    Built-in offline support is automatically provided within the LocusMaps mobile SDKs allowing users to access maps, search, directions and positioning services all without an Internet connection.
                </p>
              </li>
              <li data-bottom-top="opacity: 0;" data-center-top="opacity: 1;">
                <i className="icon">
                  <img
                    src={icon_custom}
                    width="28"
                    height="35"
                    alt="image description"
                  />
                </i>
                <h3>
                  <a href="#">Custom Theming</a>
                </h3>
                <p>
                    Integrate your own iconography, fonts, and brand colors to provide a consistent visual experience in your app.
                </p>
              </li>
              <li data-bottom-top="opacity: 0;" data-center-top="opacity: 1;">
                <i className="icon">
                  <img
                    src={icon_intelligence}
                    width="31"
                    height="31"
                    alt="image description"
                  />
                </i>
                <h3>
                  <a href="#">Analytics &amp; Intelligence</a>
                </h3>
                <p>
                    Backend reporting gives stakeholders access to user engagement analytics to understand how many and what places visitors are browsing, what they are searching for, and where foot traffic is going.
                </p>
              </li>
            </ul>
          </div>
          <div className="visual">
            <div className="pipeline">
              <img
                src={image_pipe}
                width="245"
                height="971"
                alt="image description"
              />
              <div
                className="circle"
                data-bottom-top="transform:translate(5px, 0px) rotate(-30deg); opacity:0;"
                data--580-bottom="transform:translate(5px, 0px) rotate(-30deg); opacity:0;"
                data--600-bottom="transform:translate(5px, 140px) rotate(-30deg); opacity:1;"
                data--700-bottom="transform:translate(108px, 249px) rotate(-125deg); opacity:1;"
                data--750-bottom="transform:translate(200px, 249px) rotate(-97deg); opacity:1;"
                data--790-bottom="transform:translate(240px, 249px) rotate(-37deg); opacity:1;"
                data--900-bottom="transform:translate(240px, 540px) rotate(-34deg); opacity:1;"
                data--950-bottom="transform:translate(240px, 565px) rotate(0deg); opacity:1;"
                data--1000-bottom="transform:translate(125px, 687px) rotate(0deg); opacity:1;"
                data--1020-bottom="transform:translate(125px, 700px) rotate(-24deg); opacity:1;"
                data--1070-bottom="transform:translate(125px, 810px) rotate(-30deg); opacity:1;"
                data--1080-bottom="transform:translate(125px, 820px) rotate(-30deg); opacity:1;"
                data--1180-bottom="transform:translate(125px, 1400px) rotate(-30deg); opacity:0;"
              >
                <img
                  src={image_circle2}
                  width="400"
                  height="400"
                  alt="image description"
                  data-bottom-top="transform:scale(0); opacity:1;"
                  data--600-bottom="transform:scale(0); opacity:1;"
                  data--700-bottom="transform:scale(0.5); opacity:1;"
                  data--790-bottom="transform:scale(0.5); opacity:1;"
                  data--810-bottom="transform:scale(1); opacity:0.5;"
                  data--850-bottom="transform:scale(0.3); opacity:0;"
                  data--1000-bottom="transform:scale(0.3); opacity:0.2;"
                  data--1070-bottom="transform:scale(1); opacity:1;"
                  data--1180-bottom="transform:scale(1); opacity:1;"
                />
                <div className="mark">
                  <img src={image_pin} alt="image description" />
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    )
  }
}

export default locusMapsPage



// WEBPACK FOOTER //
// ./src/pages/LocusMaps.js